<app-breadcrumb [title]="'Puntos críticos'" [items]="['Pesv', 'Desplazamientos']"
  [active_item]="'Puntos críticos del desplazamiento'"></app-breadcrumb>

<div class="container-fluid">
  <div class="card shadow-sm border-0">
    <div class="card-header bg-primary text-white d-flex align-items-center">
      <i class="icofont icofont-location-pin me-2"></i>
      <h5 class="mb-0"><strong>PUNTOS CRÍTICOS DEL DESPLAZAMIENTO</strong></h5>
      <button type="button" class="btn btn-sm btn-light ms-auto" (click)="volver()">
        <i class="icofont icofont-arrow-left me-1"></i>Volver
      </button>
    </div>

    <div class="card-body">

      <!-- INFORMACIÓN DEL DESPLAZAMIENTO -->
      <div class="card border-0 shadow-sm mb-3" *ngIf="desplazamiento">
        <div class="card-body row g-3">
          <div class="col-md-3">
            <small class="text-primary d-block">N° documento</small>
            <strong>{{ desplazamiento.n_documento || '-' }}</strong>
          </div>
          <div class="col-md-3">
            <small class="text-primary d-block">Fecha</small>
            <strong>{{ desplazamiento.fecha ? (desplazamiento.fecha | date:'dd/MM/yyyy') : '-' }}</strong>
          </div>
          <div class="col-md-3">
            <small class="text-primary d-block">Origen</small>
            <strong>{{ desplazamiento.PesvOrigenDesplazamientosData?.MUNICIPIO || '-' }}</strong>
          </div>
          <div class="col-md-3">
            <small class="text-primary d-block">Destino</small>
            <strong>{{ desplazamiento.PesvDestinoDesplazamientosData?.MUNICIPIO || '-' }}</strong>
          </div>
        </div>
      </div>

      <ul ngbNav #puntoTab="ngbNav" [(activeId)]="activeTab" class="nav-tabs">

        <!-- TAB 1: FORMULARIO -->
        <li [ngbNavItem]="1" *ngIf="desplazamientoActivo || modoEdicion">
          <a ngbNavLink><strong><i class="icofont icofont-plus me-1"></i> FORMULARIO PUNTO CRÍTICO</strong></a>
          <ng-template ngbNavContent>
            <form [formGroup]="puntoForm" (ngSubmit)="guardar()" class="pt-3" novalidate>
              <div class="card border-0 shadow-sm mb-3">
                <div class="card-body row g-3">

                  <div class="col-md-4">
                    <label class="form-label text-dark">Ubicación: <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" formControlName="ubicacion"
                      placeholder="Ej: Km 12 vía Medellín - Bogotá"
                      [class.is-invalid]="puntoForm.get('ubicacion')?.invalid && puntoForm.get('ubicacion')?.touched">
                  </div>

                  <div class="col-md-4">
                    <label class="form-label text-dark">Tipo de punto:</label>
                    <ng-select [items]="tiposPunto" bindLabel="descripcion" bindValue="id"
                      [searchable]="true" [clearable]="true"
                      placeholder="Seleccione un tipo..." formControlName="tipo_punto">
                    </ng-select>
                  </div>

                  <div class="col-md-4">
                    <label class="form-label text-dark">Nivel de riesgo:</label>
                    <ng-select [items]="nivelesRiesgo" bindLabel="descripcion" bindValue="id"
                      [searchable]="false" [clearable]="true"
                      placeholder="Seleccione un nivel..." formControlName="nivel_riesgo">
                    </ng-select>
                  </div>

                  <div class="col-md-6">
                    <label class="form-label text-dark">Descripción</label>
                    <textarea class="form-control" rows="3" formControlName="descripcion"></textarea>
                  </div>

                  <div class="col-md-6">
                    <label class="form-label text-dark">Medida de control</label>
                    <textarea class="form-control" rows="3" formControlName="medida_control"></textarea>
                  </div>

                </div>
              </div>

              <div class="d-flex justify-content-center gap-2 mt-4">
                <button type="submit" class="btn btn-primary px-4" [disabled]="guardando">
                  <span *ngIf="!guardando">
                    <i class="icofont icofont-save me-1"></i>{{ modoEdicion ? 'Actualizar' : 'Guardar' }}
                  </span>
                  <span *ngIf="guardando">
                    <span class="spinner-border spinner-border-sm me-1"></span>Guardando...
                  </span>
                </button>
                <button type="button" class="btn btn-secondary px-4" *ngIf="modoEdicion" (click)="cancelarEdicion()">
                  <i class="icofont icofont-close me-1"></i>Cancelar edición
                </button>
              </div>
            </form>
          </ng-template>
        </li>

        <!-- TAB 2: LISTADO -->
        <li [ngbNavItem]="2">
          <a ngbNavLink><strong><i class="icofont icofont-listine-dots me-1"></i> LISTADO PUNTOS CRÍTICOS</strong></a>
          <ng-template ngbNavContent>
            <div class="card card-absolute rounded mt-3 border-0 shadow-sm">
              <div class="card-body pt-3">

                <div *ngIf="cargandoListado" class="text-center py-4">
                  <div class="spinner-border text-primary" role="status"></div>
                  <p class="mt-2 mb-0">Cargando puntos críticos...</p>
                </div>

                <div class="row mb-3 align-items-center" *ngIf="!cargandoListado">
                  <div class="col-md-3">
                    <select class="form-select" [(ngModel)]="filtroEstado" (change)="aplicarFiltro()">
                      <option [ngValue]="null">Todos</option>
                      <option [ngValue]="1">Activos</option>
                      <option [ngValue]="0">Inactivos</option>
                    </select>
                  </div>
                  <div class="col-md-4 ms-auto">
                    <div class="input-group">
                      <input type="text" class="form-control"
                        placeholder="Buscar por ubicación, tipo, nivel, descripción..." [(ngModel)]="filtro"
                        (input)="aplicarFiltro()">
                      <span class="input-group-text"><i class="fa fa-search"></i></span>
                    </div>
                  </div>
                </div>

                <div *ngIf="!cargandoListado" class="table-responsive mt-2">
                  <ng-container *ngIf="puntosFiltrados.length > 0; else sinDatos">
                    <table id="tblPuntosCriticos" class="table table-bordered table-hover align-middle">
                      <thead class="bg-primary text-white">
                        <tr>
                          <th class="text-center">UBICACIÓN</th>
                          <th class="text-center">TIPO DE PUNTO</th>
                          <th class="text-center">NIVEL</th>
                          <th class="text-center">DESCRIPCIÓN</th>
                          <th class="text-center">MEDIDA DE CONTROL</th>
                          <th class="text-center">ESTADO</th>
                          <th class="text-center">ACCIONES</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let p of puntosFiltrados | paginate: { itemsPerPage: pageSize, currentPage: page }">
                          <td class="text-center">{{ p.ubicacion }}</td>
                          <td class="text-center">{{ p.TipoPuntoPuntosData?.descripcion || '-' }}</td>
                          <td class="text-center">{{ p.NivelRiesgoPuntosData?.descripcion || '-' }}</td>
                          <td>{{ p.descripcion || '-' }}</td>
                          <td>{{ p.medida_control || '-' }}</td>
                          <td class="text-center">
                            <span class="badge rounded-pill" [ngClass]="{
                                'bg-success': p.estado === 1,
                                'bg-secondary': p.estado !== 1
                              }">
                              {{ p.estado === 1 ? 'Activo' : 'Inactivo' }}
                            </span>
                          </td>
                          <td class="text-center">
                            <div class="d-flex justify-content-center gap-1">
                              <button class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                                ngbTooltip="Editar" *ngIf="p.estado === 1" (click)="editar(p)">
                                <i class="icofont icofont-pencil" style="font-size:.85rem;"></i>
                              </button>
                              <button class="btn btn-sm btn-outline-danger rounded-pill btn-rounded"
                                ngbTooltip="Inactivar" *ngIf="p.estado === 1" (click)="inactivar(p)">
                                <i class="icofont icofont-close" style="font-size:.85rem;"></i>
                              </button>
                              <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                ngbTooltip="Activar" *ngIf="p.estado !== 1" (click)="activar(p)">
                                <i class="icofont icofont-check" style="font-size:.85rem;"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div class="d-flex justify-content-between align-items-center mt-4">
                      <div class="d-flex align-items-center">
                        <label class="me-2">Mostrar:</label>
                        <select class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
                          <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
                        </select>
                        <span class="ms-2">registros por página</span>
                      </div>
                      <div class="text-center flex-grow-1">
                        Total Registros: <a class="badge badge-primary"><b>{{ puntosFiltrados.length || 0
                            }}</b></a>
                      </div>
                      <div class="text-end">
                        <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
                          [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
                      </div>
                    </div>
                  </ng-container>

                  <ng-template #sinDatos>
                    <div class="text-center py-4 text-primary">No hay puntos críticos registrados para este desplazamiento.</div>
                  </ng-template>
                </div>

                <div class="mt-4">
                  <div class="btn-showcase text-center">
                    <button class="btn btn-outline-success-2x" type="button" ngbTooltip="Exportar a Excel"
                      (click)="exportarExcel('tblPuntosCriticos','listado_puntos_criticos')">
                      <i class="icofont icofont-file-excel"></i> EXCEL
                    </button>
                    <button class="btn btn-outline-danger-2x" type="button" ngbTooltip="Exportar a PDF"
                      (click)="exportToPDF('tblPuntosCriticos','listado_puntos_criticos','Listado de puntos críticos del desplazamiento')">
                      <i class="icofont icofont-file-pdf"></i> PDF
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </li>
      </ul>

      <div [ngbNavOutlet]="puntoTab" class="mt-2"></div>
    </div>
  </div>
</div>